export const SET_CONTENT_REQUEST = 'SET_CONTENT_REQUEST'
export const CONTENT_REQUEST = 'CONTENT_REQUEST'
export const CONTENT_SUCCESS = 'CONTENT_SUCCESS'
export const CONTENT_ERROR = 'CONTENT_ERROR'
